import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/icon-plus-white.svg'
import _imports_1 from '@/assets/icons/icon-export.svg'
import _imports_2 from '@/assets/icons/plus-black.svg'
import _imports_3 from '@/assets/icons/edit.svg'
import _imports_4 from '@/assets/icons/trash-black.svg'


const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "default-count" }
const _hoisted_4 = { class: "table-wrapper" }
const _hoisted_5 = { class: "table-card" }
const _hoisted_6 = { class: "filter-bar" }
const _hoisted_7 = { class: "filter-section" }
const _hoisted_8 = { class: "filter-btn dropdown-button" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "action-buttons" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-small"
}
const _hoisted_13 = {
  key: 1,
  class: "export-icon",
  src: _imports_1
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "leads-info-bar" }
const _hoisted_17 = {
  key: 0,
  class: "leads-count-text"
}
const _hoisted_18 = {
  key: 1,
  class: "bulk-operations"
}
const _hoisted_19 = { class: "selection-info" }
const _hoisted_20 = { class: "actions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-small"
}
const _hoisted_23 = {
  key: 1,
  class: "invite-icon",
  src: _imports_2
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_27 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 0,
  class: "leads-card-view"
}
const _hoisted_30 = { class: "card-header" }
const _hoisted_31 = { class: "checkbox-wrapper" }
const _hoisted_32 = ["checked", "onChange"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_35 = {
  key: 1,
  class: "field-display"
}
const _hoisted_36 = { class: "lead-name" }
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = { class: "card-row" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_41 = {
  key: 1,
  class: "field-display"
}
const _hoisted_42 = { class: "card-row" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_45 = {
  key: 1,
  class: "field-display"
}
const _hoisted_46 = { class: "card-row" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "card-row" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "field-display" }
const _hoisted_51 = { class: "card-row" }
const _hoisted_52 = { class: "field-display" }
const _hoisted_53 = { class: "card-row" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onUpdate:modelValue", "onBlur", "onKeydown"]
const _hoisted_56 = {
  key: 1,
  class: "field-display notes-display"
}
const _hoisted_57 = {
  key: 1,
  class: "table-container"
}
const _hoisted_58 = { class: "table-scroll" }
const _hoisted_59 = { class: "leads-table" }
const _hoisted_60 = { class: "checkbox-header" }
const _hoisted_61 = ["checked"]
const _hoisted_62 = { class: "checkbox-cell" }
const _hoisted_63 = ["checked", "onChange"]
const _hoisted_64 = { class: "sticky-column name-cell" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_67 = {
  key: 1,
  class: "field-display"
}
const _hoisted_68 = { class: "lead-name" }
const _hoisted_69 = { class: "standard-cell status-cell" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "standard-cell email-cell" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_74 = {
  key: 1,
  class: "field-display"
}
const _hoisted_75 = { class: "standard-cell phone-cell" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onUpdate:modelValue", "onBlur", "onKeyup"]
const _hoisted_78 = {
  key: 1,
  class: "field-display"
}
const _hoisted_79 = { class: "standard-cell source-cell" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "field-display" }
const _hoisted_82 = { class: "standard-cell date-cell non-editable-date" }
const _hoisted_83 = { class: "field-display" }
const _hoisted_84 = { class: "standard-cell notes-cell" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onUpdate:modelValue", "onBlur", "onKeydown"]
const _hoisted_87 = {
  key: 1,
  class: "field-display notes-display"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title-row" }, [
        _createElementVNode("div", { class: "title-main" }, "Leads")
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.plural($setup.leads.length, "Lead")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_8, _toDisplayString($setup.activeFilter.label), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      onClick: ($event: any) => ($setup.changeFilter(item)),
                      class: _normalizeClass({ active: $setup.activeFilter.label === item.label })
                    }, _toDisplayString(item.label), 11, _hoisted_9))
                  }), 256))
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "action-button create-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCreateModal = true))
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("img", {
                class: "plus-icon",
                src: _imports_0
              }, null, -1),
              _createTextVNode("Create Lead", -1)
            ]))]),
            _createElementVNode("button", {
              class: "action-button export-button",
              onClick: $setup.exportLeads,
              disabled: $setup.isExportingLeads
            }, [
              ($setup.isExportingLeads)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : (_openBlock(), _createElementBlock("img", _hoisted_13)),
              ($setup.isExportingLeads)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Exporting..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "Export Leads"))
            ], 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          ($setup.selectedLeadsList.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.plural($setup.leads.length, "Lead")) + " found", 1))
            : _createCommentVNode("", true),
          ($setup.selectedLeadsList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString($setup.plural($setup.selectedLeadsList.length, "lead")) + " selected", 1),
                _createElementVNode("div", _hoisted_20, [
                  (!$setup.isEstateCollaborator && $setup.estate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "action-btn invite",
                        onClick: $setup.inviteToWaitlist,
                        disabled: $setup.isInvitingToWaitlist
                      }, [
                        ($setup.isInvitingToWaitlist)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                          : _createCommentVNode("", true),
                        (!$setup.isInvitingToWaitlist)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                          : _createCommentVNode("", true),
                        (!$setup.isInvitingToWaitlist)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Invite to waitlist"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_25, "Sending invitations..."))
                      ], 8, _hoisted_21))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "action-btn status",
                    onClick: $setup.openBulkStatusModal
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("img", {
                      class: "status-icon",
                      src: _imports_3
                    }, null, -1),
                    _createTextVNode("Update Status", -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "action-btn delete",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmBulkDeleteModal = true))
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("img", {
                      class: "delete-icon",
                      src: _imports_4
                    }, null, -1),
                    _createTextVNode("Delete leads", -1)
                  ]))])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("div", { class: "spinner" }, null, -1)
            ]))]))
          : ($setup.isEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("img", {
                  class: "empty-icon",
                  src: require('@/assets/icons/contacts-slim.svg')
                }, null, 8, _hoisted_28),
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "empty-text" }, "Your leads list is empty", -1))
              ]))
            : (!$setup.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  ($setup.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.leads, (lead, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "lead-card",
                            key: lead._id
                          }, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("input", {
                                  class: "checkbox-input",
                                  type: "checkbox",
                                  checked: $setup.leadList[index].selected,
                                  onChange: ($event: any) => ($setup.selectLead($event.target.checked, index))
                                }, null, 40, _hoisted_32)
                              ]),
                              _createElementVNode("div", {
                                class: "editable-field",
                                onClick: ($event: any) => ($setup.startEdit(lead, 'name'))
                              }, [
                                ($setup.editingField === `${lead._id}-name`)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      class: "field-input",
                                      "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-name`]) = $event),
                                      onBlur: ($event: any) => ($setup.saveField(lead, 'name')),
                                      onKeyup: [
                                        _withKeys(($event: any) => ($setup.saveField(lead, 'name')), ["enter"]),
                                        _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"]))
                                      ],
                                      type: "text"
                                    }, null, 40, _hoisted_34)), [
                                      [_vModelText, $setup.editValues[`${lead._id}-name`]]
                                    ])
                                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, _toDisplayString(lead?.firstName) + " " + _toDisplayString(lead?.lastName), 1)
                                    ]))
                              ], 8, _hoisted_33)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "label" }, "Email", -1)),
                                _createElementVNode("div", {
                                  class: "editable-field value",
                                  onClick: ($event: any) => ($setup.startEdit(lead, 'email'))
                                }, [
                                  ($setup.editingField === `${lead._id}-email`)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        class: "field-input",
                                        "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-email`]) = $event),
                                        onBlur: ($event: any) => ($setup.saveField(lead, 'email')),
                                        onKeyup: [
                                          _withKeys(($event: any) => ($setup.saveField(lead, 'email')), ["enter"]),
                                          _cache[3] || (_cache[3] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"]))
                                        ],
                                        type: "text"
                                      }, null, 40, _hoisted_40)), [
                                        [_vModelText, $setup.editValues[`${lead._id}-email`]]
                                      ])
                                    : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(lead?.email || "--"), 1))
                                ], 8, _hoisted_39)
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label" }, "Phone", -1)),
                                _createElementVNode("div", {
                                  class: "editable-field value",
                                  onClick: ($event: any) => ($setup.startEdit(lead, 'phone'))
                                }, [
                                  ($setup.editingField === `${lead._id}-phone`)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        class: "field-input",
                                        "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-phone`]) = $event),
                                        onBlur: ($event: any) => ($setup.saveField(lead, 'phone')),
                                        onKeyup: [
                                          _withKeys(($event: any) => ($setup.saveField(lead, 'phone')), ["enter"]),
                                          _cache[4] || (_cache[4] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"]))
                                        ],
                                        type: "text"
                                      }, null, 40, _hoisted_44)), [
                                        [_vModelText, $setup.editValues[`${lead._id}-phone`]]
                                      ])
                                    : (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(lead?.phone || "--"), 1))
                                ], 8, _hoisted_43)
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "label" }, "Status", -1)),
                                _createElementVNode("div", {
                                  class: "value",
                                  onClick: _withModifiers(($event: any) => ($setup.openStatusModal(lead)), ["stop"])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["badge", $setup.getLeadStatusClass(lead?.status)])
                                  }, _toDisplayString(lead?.status), 3)
                                ], 8, _hoisted_47)
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "label" }, "Source", -1)),
                                _createElementVNode("div", {
                                  class: "editable-field value",
                                  onClick: ($event: any) => ($setup.openSourceModal(lead))
                                }, [
                                  _createElementVNode("div", _hoisted_50, _toDisplayString(lead?.source === $setup.LeadSourceEnum.INITIAL_HOLD ? "Hold Request" : lead?.source), 1)
                                ], 8, _hoisted_49)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "label" }, "Created", -1)),
                                _createElementVNode("div", {
                                  class: "non-editable-field value",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showCreatedAtNotification()))
                                }, [
                                  _createElementVNode("div", _hoisted_52, _toDisplayString($setup.formatDate(lead?.createdAt, "DD MMM YYYY")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "label" }, "Notes", -1)),
                                _createElementVNode("div", {
                                  class: "editable-field value notes-field",
                                  onClick: ($event: any) => ($setup.startEdit(lead, 'notes'))
                                }, [
                                  ($setup.editingField === `${lead._id}-notes`)
                                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                        key: 0,
                                        class: "field-textarea",
                                        "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-notes`]) = $event),
                                        onBlur: ($event: any) => ($setup.saveField(lead, 'notes')),
                                        onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"])),
                                        rows: "2",
                                        onKeydown: _withKeys(_withModifiers(($event: any) => ($setup.saveField(lead, 'notes')), ["prevent"]), ["enter"])
                                      }, null, 40, _hoisted_55)), [
                                        [_vModelText, $setup.editValues[`${lead._id}-notes`]]
                                      ])
                                    : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(lead?.notes || "--"), 1))
                                ], 8, _hoisted_54)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("table", _hoisted_59, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_60, [
                                  _createElementVNode("input", {
                                    class: "checkbox-input",
                                    type: "checkbox",
                                    checked: $setup.isSelectAll,
                                    onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.selectAll($event.target.checked)))
                                  }, null, 40, _hoisted_61)
                                ]),
                                _cache[27] || (_cache[27] = _createElementVNode("th", { class: "sticky-column name-header" }, "Name", -1)),
                                _cache[28] || (_cache[28] = _createElementVNode("th", { class: "standard-header status-header" }, "Status", -1)),
                                _cache[29] || (_cache[29] = _createElementVNode("th", { class: "standard-header email-header" }, "Email", -1)),
                                _cache[30] || (_cache[30] = _createElementVNode("th", { class: "standard-header phone-header" }, "Phone", -1)),
                                _cache[31] || (_cache[31] = _createElementVNode("th", { class: "standard-header source-header" }, "Source", -1)),
                                _cache[32] || (_cache[32] = _createElementVNode("th", { class: "standard-header date-header" }, "Created", -1)),
                                _cache[33] || (_cache[33] = _createElementVNode("th", { class: "standard-header notes-header" }, "Notes", -1))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.leads, (lead, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: lead._id
                                }, [
                                  _createElementVNode("td", _hoisted_62, [
                                    _createElementVNode("input", {
                                      class: "checkbox-input",
                                      type: "checkbox",
                                      checked: $setup.leadList[index].selected,
                                      onChange: ($event: any) => ($setup.selectLead($event.target.checked, index))
                                    }, null, 40, _hoisted_63)
                                  ]),
                                  _createElementVNode("td", _hoisted_64, [
                                    _createElementVNode("div", {
                                      class: "editable-field",
                                      onClick: ($event: any) => ($setup.startEdit(lead, 'name'))
                                    }, [
                                      ($setup.editingField === `${lead._id}-name`)
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            class: "field-input",
                                            "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-name`]) = $event),
                                            onBlur: ($event: any) => ($setup.saveField(lead, 'name')),
                                            onKeyup: [
                                              _withKeys(($event: any) => ($setup.saveField(lead, 'name')), ["enter"]),
                                              _cache[8] || (_cache[8] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"]))
                                            ],
                                            ref_for: true,
                                            ref: "nameInput",
                                            type: "text"
                                          }, null, 40, _hoisted_66)), [
                                            [_vModelText, $setup.editValues[`${lead._id}-name`]]
                                          ])
                                        : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                            _createElementVNode("span", _hoisted_68, _toDisplayString(lead?.firstName) + " " + _toDisplayString(lead?.lastName), 1)
                                          ]))
                                    ], 8, _hoisted_65)
                                  ]),
                                  _createElementVNode("td", _hoisted_69, [
                                    _createElementVNode("div", {
                                      class: "status-badges",
                                      onClick: _withModifiers(($event: any) => ($setup.openStatusModal(lead)), ["stop"])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["badge", $setup.getLeadStatusClass(lead?.status)])
                                      }, _toDisplayString(lead?.status), 3)
                                    ], 8, _hoisted_70)
                                  ]),
                                  _createElementVNode("td", _hoisted_71, [
                                    _createElementVNode("div", {
                                      class: "editable-field",
                                      onClick: ($event: any) => ($setup.startEdit(lead, 'email'))
                                    }, [
                                      ($setup.editingField === `${lead._id}-email`)
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            class: "field-input",
                                            "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-email`]) = $event),
                                            onBlur: ($event: any) => ($setup.saveField(lead, 'email')),
                                            onKeyup: [
                                              _withKeys(($event: any) => ($setup.saveField(lead, 'email')), ["enter"]),
                                              _cache[9] || (_cache[9] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"]))
                                            ],
                                            ref_for: true,
                                            ref: "emailInput",
                                            type: "text"
                                          }, null, 40, _hoisted_73)), [
                                            [_vModelText, $setup.editValues[`${lead._id}-email`]]
                                          ])
                                        : (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(lead?.email || "--"), 1))
                                    ], 8, _hoisted_72)
                                  ]),
                                  _createElementVNode("td", _hoisted_75, [
                                    _createElementVNode("div", {
                                      class: "editable-field",
                                      onClick: ($event: any) => ($setup.startEdit(lead, 'phone'))
                                    }, [
                                      ($setup.editingField === `${lead._id}-phone`)
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            class: "field-input",
                                            "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-phone`]) = $event),
                                            onBlur: ($event: any) => ($setup.saveField(lead, 'phone')),
                                            onKeyup: [
                                              _withKeys(($event: any) => ($setup.saveField(lead, 'phone')), ["enter"]),
                                              _cache[10] || (_cache[10] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"]))
                                            ],
                                            ref_for: true,
                                            ref: "phoneInput",
                                            type: "text"
                                          }, null, 40, _hoisted_77)), [
                                            [_vModelText, $setup.editValues[`${lead._id}-phone`]]
                                          ])
                                        : (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(lead?.phone || "--"), 1))
                                    ], 8, _hoisted_76)
                                  ]),
                                  _createElementVNode("td", _hoisted_79, [
                                    _createElementVNode("div", {
                                      class: "editable-field",
                                      onClick: ($event: any) => ($setup.openSourceModal(lead))
                                    }, [
                                      _createElementVNode("div", _hoisted_81, _toDisplayString(lead?.source === $setup.LeadSourceEnum.INITIAL_HOLD ? "Hold Request" : lead?.source), 1)
                                    ], 8, _hoisted_80)
                                  ]),
                                  _createElementVNode("td", _hoisted_82, [
                                    _createElementVNode("div", {
                                      class: "non-editable-field",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.showCreatedAtNotification()))
                                    }, [
                                      _createElementVNode("div", _hoisted_83, _toDisplayString($setup.formatDate(lead?.createdAt, "DD MMM YYYY")), 1)
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_84, [
                                    _createElementVNode("div", {
                                      class: "editable-field notes-field",
                                      onClick: ($event: any) => ($setup.startEdit(lead, 'notes'))
                                    }, [
                                      ($setup.editingField === `${lead._id}-notes`)
                                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                            key: 0,
                                            class: "field-textarea",
                                            "onUpdate:modelValue": ($event: any) => (($setup.editValues[`${lead._id}-notes`]) = $event),
                                            onBlur: ($event: any) => ($setup.saveField(lead, 'notes')),
                                            onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => ($setup.cancelEdit()), ["escape"])),
                                            ref_for: true,
                                            ref: "notesInput",
                                            rows: "2",
                                            onKeydown: _withKeys(_withModifiers(($event: any) => ($setup.saveField(lead, 'notes')), ["prevent"]), ["enter"])
                                          }, null, 40, _hoisted_86)), [
                                            [_vModelText, $setup.editValues[`${lead._id}-notes`]]
                                          ])
                                        : (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(lead?.notes || "--"), 1))
                                    ], 8, _hoisted_85)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                ], 64))
              : _createCommentVNode("", true)
      ])
    ]),
    _createVNode($setup["StatusModal"], {
      isOpen: $setup.showStatusModal,
      currentStatus: $setup.selectedLead?.status,
      onClose: $setup.closeStatusModal,
      onConfirm: $setup.handleStatusUpdate
    }, null, 8, ["isOpen", "currentStatus"]),
    _createVNode($setup["BulkStatusModal"], {
      isOpen: $setup.showBulkStatusModal,
      selectedCount: $setup.selectedLeadsList.length,
      onClose: $setup.closeBulkStatusModal,
      onConfirm: $setup.handleBulkStatusUpdate
    }, null, 8, ["isOpen", "selectedCount"]),
    _createVNode($setup["SourceModal"], {
      isOpen: $setup.showSourceModal,
      currentSource: $setup.editingLead?.source,
      onClose: $setup.closeSourceModal,
      onConfirm: $setup.handleSourceUpdate
    }, null, 8, ["isOpen", "currentSource"]),
    _createVNode($setup["CreateLeadModal"], {
      isOpen: $setup.showCreateModal,
      onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.showCreateModal = false)),
      onUpdate: $setup.getLeads
    }, null, 8, ["isOpen"]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmBulkDeleteModal,
      deleteItem: $setup.selectedLeadsList.length,
      onClose: _cache[14] || (_cache[14] = ($event: any) => ($setup.showConfirmBulkDeleteModal = false)),
      onConfirm: $setup.bulkDeleteLeads
    }, null, 8, ["isOpen", "deleteItem"])
  ]))
}